export class PaymentStateManager {
  constructor() {

    this.userValues = {
      order_id     : '',
      order_items  : [],
      payment_nonce: ''
    }
  }

  hasOrders() {
    return this.userValues.order_items.length > 0
  }

  orderItemsGet() {
    return this.userValues.order_items
  }

  ordersGetCurrentIndex() {
    return this.userValues.order_items.length ? this.userValues.order_items.length - 1 : 0
  }


  orderCheckIfExists(orderNo) {
    return this.userValues.order_items.reduce((orderExists, order) => {
      return order.order_item_no === orderNo ? true : orderExists
    }, false)
  }

  orderAdd(order) {
    this.userValues.order_items.push(order)
  }

  orderRemoveItemAtIndex(orderNo) {
    if (this.userValues.order_items[orderNo]) {
      this.userValues.order_items.splice(orderNo, 1)
    }
  }

  orderItemAtIndexGet(index) {
    const values = (typeof this.userValues.order_items[index] === 'undefined') ? {} : JSON.parse(JSON.stringify(this.userValues.order_items[index]))

    Object.keys(this.userValues).forEach(key => {
      if (key !== 'order_items') {
        if (typeof values !== 'undefined') {
          values[key] = this.userValues[key]
        }
      }
    })

    return values
  }

  orderItemAtIndexIsGift(index) {
    if (typeof this.userValues.order_items[index] === 'undefined') {
      return  false
    }

    return this.userValues.order_items[index]['is_gift']
  }

  orderItemAtIndexUpdate(index, name, value) {
    if (typeof this.userValues.order_items[index] === 'undefined') {
      throw 'Item not found'
    }

    this.userValues.order_items[index][name] = value
  }

  paymentHasCompleted = () => {
    return this.userValues.order_id !== '' || this.userValues.payment_nonce !== ''
  }

  paymentTypeGet() {
    return this.userValues.payment_type ? this.userValues.payment_type : ''
  }

  valueUpdate(name, value) {
    this.userValues[name] = value
  }

  valuesGet() {
    const values = JSON.parse(JSON.stringify(this.userValues))

    if (values.order_items.length) {
      values.payment_amount = this.userValues.order_items.reduce((amount, current) => {
        return amount + parseFloat(current.amount)
      }, 0).toString()
    }

    return values
  }

  valuesSet(values) {
    Object.keys(values).forEach(key => {
      if (typeof this.userValues[key] === 'undefined') {
        this.userValues[key] = values[key]
      }
    })

    if (typeof values.order_items !== 'undefined' && Array.isArray(values.order_items)) {
      values.order_items.forEach(orderItem => {
        if (orderItem.order_item_no && !this.orderCheckIfExists(orderItem.order_item_no)) {
          this.userValues.order_items.push(orderItem)
        }
      })
    }
  }
}
